module.exports = __webpack_public_path__ + "img/canoaWhite.6d47ef37.svg";